import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-RS",
  "use": "icon-RS-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 40 40\" id=\"icon-RS\"><g><rect x=\"0\" y=\"0\" width=\"40\" height=\"40\" rx=\"6\" fill=\"#FF6600\" fill-opacity=\"0.800000011920929\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol